import React from 'react';
import classnames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import { GooglePay } from '../../../payment-methods/GooglePay';
import { ApplePay } from '../../../payment-methods/ApplePay';
import { DH } from '../../../../utils/dataHooks';
import { MorePaymentOptions } from '../../../MorePaymentOptions';
import { PayPalElem, PayPalElems, SecondaryPoWrapper } from '../../elements';
import s from '../../styles.scss';

const TRANSITION_TIMEOUT = 400;

export interface VerticalListViewProps {
  onMorePaymentOptionsClick(): void;
  availablePmsList: {
    googlePay: boolean;
    applePay: boolean;
    payPal: string[];
  };
  isCollapsed: boolean;
}
export const VerticalListView: React.FC<VerticalListViewProps> = (props) => {
  const { availablePmsList, isCollapsed, onMorePaymentOptionsClick } = props;
  const hasApplePay = !!availablePmsList.applePay;
  const hasGooglePay = !!availablePmsList.googlePay;
  const [mainPayPalSource, ...restPayPalSources] = availablePmsList.payPal;
  const secondPayPalSource = !hasApplePay && restPayPalSources.shift();
  const hasRestPms = restPayPalSources.length > 0;

  return (
    <div data-hook={DH.Widget.PMList} className={classnames(s.layout, s.vertical)}>
      {hasApplePay && (
        <div className={s.layoutItem}>
          <ApplePay />
        </div>
      )}
      {mainPayPalSource && <PayPalElem fundingSource={mainPayPalSource} mainSource={true}></PayPalElem>}
      {secondPayPalSource && <PayPalElem fundingSource={secondPayPalSource} mainSource={false}></PayPalElem>}
      {hasRestPms && (
        <>
          <CSSTransition
            in={!isCollapsed}
            timeout={TRANSITION_TIMEOUT}
            classNames={{
              enter: s.enter,
              enterActive: s.enterActive,
              enterDone: s.enterDone,
            }}
          >
            <SecondaryPoWrapper>
              <PayPalElems fundingSources={restPayPalSources}></PayPalElems>
            </SecondaryPoWrapper>
          </CSSTransition>
          <CSSTransition
            in={isCollapsed}
            timeout={TRANSITION_TIMEOUT}
            classNames={{
              exit: s.exit,
              exitActive: s.exitActive,
              exitDone: s.exitDone,
            }}
          >
            <div data-hook={DH.Widget.MorePoWrapper} data-hidden={!isCollapsed}>
              <MorePaymentOptions onClick={onMorePaymentOptionsClick}></MorePaymentOptions>
            </div>
          </CSSTransition>
        </>
      )}
      {hasGooglePay && (
        <div className={s.layoutItem}>
          <GooglePay />
        </div>
      )}
    </div>
  );
};
